import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const adhesionesDebitoAdapter = createEntityAdapter({
    selectId: (x) => x.adhesionDebitoId,
});
const initialState = adhesionesDebitoAdapter.getInitialState();


export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAdhesionesDebito: builder.query({
            query: () => 'adhesiones-debito',
            transformResponse: responseData => {
                return adhesionesDebitoAdapter.setAll(initialState, responseData)
            },
            providesTags: (result, error, arg) => [
                { type: 'AdhesionesDebito', id: 'LIST' }
            ]
        }),
        deleteAdhesionesDebito: builder.mutation({
            query: (idsAdhesionesToDelete) => ({
                url: 'adhesiones-debito',
                method: 'delete',
                body: idsAdhesionesToDelete
            }),
            invalidatesTags: ["AdhesionesDebito", "AdhesionesClientesMap"]
        }),
        addAdhesiones: builder.mutation({
            query: (newAdhesiones) => ({
                url: 'adhesiones-debito',
                method: 'post',
                body: newAdhesiones
            }),
            invalidatesTags: ["AdhesionesDebito", "AdhesionesClientesMap", "Personas"]
        }),
    })
});


export const { useGetAdhesionesDebitoQuery, useAddAdhesionesMutation, useDeleteAdhesionesDebitoMutation } = extendedApiSlice;

//A: returns the query result object
export const selectAdhesionesDebitoResult = extendedApiSlice.endpoints.getAdhesionesDebito.select();

//A: created memoized selector
const selectAdhesionesDebitoData = createSelector(
    selectAdhesionesDebitoResult,
    adhesionesDebitoResult => adhesionesDebitoResult.data  //A: normalized state object with ids and entities
);


//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllAdhesionesDebito,
    selectById: selectAllAdhesionesDebitoById,
    selectIds: selectAdhesionesDebitoIds
} = adhesionesDebitoAdapter.getSelectors(state => selectAdhesionesDebitoData(state) ?? initialState);